export const NOTIFICATIONS_LOADING  = "NOTIFICATIONS_LOADING";
export const SET_NOTIFICATIONS  = "SET_NOTIFICATIONS";